const hasTextContent = (html: string): boolean => {
    if (!html || html.trim().length === 0) {
        return false;
    }

    // Remove all HTML tags
    const withoutTags = html.replace(/<[^>]*>/g, '');
    // Remove HTML entities like &nbsp;, &amp;, etc.
    const withoutEntities = withoutTags.replace(/&[a-z0-9#]+;/gi, '');
    // Remove all whitespace (spaces, newlines, tabs, etc.)
    const trimmed = withoutEntities.replace(/\s+/g, '').trim();

    return trimmed.length > 0;
};

interface Props {
    ui: {
        setters: {
            setDescription: (value: string) => void;
        };
    };
}

export const useCustomReportTextLogic = ({ ui }: Props) => {
    const onEditorDescription = (value: string) => {
        ui.setters.setDescription(value);
    };

    return {
        logic: {
            onEditorDescription,
            hasTextContent,
        },
    };
};
